<template>
    <table class="creditNotes">
        <tbody v-if="relatedDocType === 'invoice'">
            <tr v-for="(row, index) in data.related_documents" :key="row.id">
                <td></td>
                <td>
                    <p
                        v-if="!row.obligation_type.has_auto_doc_number"
                        class="has-text-centered has-text-weight-semibold"
                    >
                        {{ row.document_number }}
                    </p>
                </td>
                <td>
                    <p class="is-size-7 has-text-centered is-uppercase">
                        {{ row.obligation_type.name }}
                    </p>
                </td>
                <td>
                    <p class="has-text-weight-semibold">
                        {{ operationStatus(index) }}
                    </p>
                </td>
                <td colspan="2">
                    <p
                        class="document-amount is-size-6 is-family-monospace has-text-right has-text-weight-semibold"
                    >
                        {{ toMoney(row.amount) }}
                    </p>
                </td>
                <td></td>
            </tr>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td>
                    <p class="has-text-weight-semibold">
                        Monto factura inicial
                    </p>
                </td>
                <td colspan="2">
                    <p
                        class="document-amount is-size-6 is-family-monospace has-text-right has-text-weight-semibold"
                    >
                        {{ toMoney(data.amount) }}
                    </p>
                </td>
                <td></td>
            </tr>
        </tbody>

        <tbody v-if="relatedDocType === 'ticket'">
            <tr v-if="creditNote">
                <td></td>
                <td></td>
                <td>
                    <p class="is-size-7 has-text-centered is-uppercase">
                        {{ creditNote.name }}
                    </p>
                </td>
                <td>
                    <p class="has-text-weight-semibold">
                        Rectifica
                    </p>
                </td>
                <td colspan="2" class="has-text-right">
                    <span class="is-inline-block has-text-secondary mr-3"
                        >-</span
                    >
                    <p
                        class="is-inline-block document-amount is-size-6 is-family-monospace has-text-weight-semibold"
                    >
                        {{ toMoney(creditNote.total_amount) }}
                    </p>
                </td>
                <td></td>
            </tr>
            <tr v-if="debitNote">
                <td></td>
                <td></td>
                <td>
                    <p class="is-size-7 has-text-centered is-uppercase">
                        {{ debitNote.name }}
                    </p>
                </td>
                <td>
                    <p class="has-text-weight-semibold">
                        Rectifica
                    </p>
                </td>
                <td colspan="2" class="has-text-right">
                    <span class="is-inline-block has-text-secondary mr-3"
                        >+</span
                    >
                    <p
                        class="is-inline-block document-amount is-size-6 is-family-monospace has-text-weight-semibold"
                    >
                        {{ toMoney(debitNote.total_amount) }}
                    </p>
                </td>
                <td></td>
            </tr>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td>
                    <p class="has-text-weight-semibold">
                        Monto factura inicial
                    </p>
                </td>
                <td colspan="2">
                    <p
                        class="document-amount is-size-6 is-family-monospace has-text-right has-text-weight-semibold"
                    >
                        {{ toMoney(data.amount) }}
                    </p>
                </td>
                <td></td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import { parseToMoney } from "@/utils/currency";

export default {
    name: "Detail",
    props: ["data"],
    data() {
        return {
            widget: () => {},
        };
    },
    methods: {
        toMoney: parseToMoney,
        operationStatus(index) {
            if (this.data.operation_status === "A" && index === 0) {
                return `Anula ${this.data.document_number}`;
            } else {
                return `Rectifica ${this.data.document_number}`;
            }
        },
    },
    computed: {
        relatedDocType() {
            if (this.data?.related_documents[0]?.name === "Nota de crédito")
                return "ticket";
            else return "invoice";
        },
        creditNote() {
            return this.data?.related_documents.find(
                (val) => val.name === "Nota de crédito"
            );
        },
        debitNote() {
            return this.data?.related_documents.find(
                (val) => val.name === "Nota de débito"
            );
        },
    },
};
</script>
